import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'fa',
        values: {
            cancel: 'fas fa-ban',
            key: 'fas fa-key',
            user: 'fas fa-user'
          }
    },
    theme: {
        themes: {
            dark: {
                primary: '#3f51b5',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#fb8c00',
            },
            light: {
                primary: '#42b983',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#fb8c00',
            },
        },
    },
});
